import { render, staticRenderFns } from "./GiftCardTicketBoxHeader.vue?vue&type=template&id=3ad55714&"
import script from "./GiftCardTicketBoxHeader.vue?vue&type=script&lang=js&"
export * from "./GiftCardTicketBoxHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports